import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@progress/kendo-angular-inputs';

import { FormlyFieldSwitch } from './switch.type';
import { FormlyFormFieldModule } from '../form-field/public_api';

@NgModule({
    declarations: [FormlyFieldSwitch],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        InputsModule,
        FormlyFormFieldModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'kendo-switch',
                    component: FormlyFieldSwitch,
                    wrappers: ['simple-form-field'],
                }
            ],
        }),
    ],
})
export class FormlySwitchModule { }
